export default "__VITE_ASSET__c12b5322__"